// extracted by mini-css-extract-plugin
export default {"pagination":"pagination_pagination__HLqrA","ellipsis":"pagination_ellipsis__Zl6Re","active":"pagination_active__WMM5f","paginationContainer":"pagination_paginationContainer__DtOOa"};